import { OBJECT_2025_BASE, ZEPETO_ASSETS_BASE } from 'util/constants';
import { zepetoItems } from '@src/components/menu/zepeto-items';

export const CATEGORIES = [
  'Animals',
  'Artifacts',
  'Art Deco',
  'Avatar',
  'Bridges',
  'Building',
  'Plants',
  'Vehicle',
  'Furniture',
];

export const itemsTypes = [
  {
    name: 'Animal_',
    alias: 'ANIMAL_',
    imgAlias: 'Animal_',
    basePath: `${ZEPETO_ASSETS_BASE}/ANIMALS+`,
    totalCount: 10,
    imgExtension: '.jpg',
    categoryName: 'Animals',
  },
  {
    name: 'Animal_',
    alias: 'Animal_',
    imgAlias: 'Animal_',
    basePath: `${OBJECT_2025_BASE}/Animal`,
    previewPath: `${OBJECT_2025_BASE}/Animal/0_Preview`,
    totalCount: 31,
    imgExtension: '.jpg',
    categoryName: 'Animals',
    customStructure: true,
  },
  {
    name: 'Artifact_',
    alias: 'ARTIFACT_',
    imgAlias: 'Artifact_',
    basePath: `${ZEPETO_ASSETS_BASE}/ARTIFACTS`,
    totalCount: 21,
    imgExtension: '.jpg',
    categoryName: 'Artifacts',
  },
  {
    name: 'Art_',
    alias: 'ART_',
    imgAlias: 'Art_',
    basePath: `${ZEPETO_ASSETS_BASE}/ART_DECO`,
    totalCount: 9,
    imgExtension: '.jpg',
    categoryName: 'Art Deco',
  },
  {
    name: 'Art_',
    alias: 'Art_',
    imgAlias: 'Art_',
    basePath: `${OBJECT_2025_BASE}/Art`,
    previewPath: `${OBJECT_2025_BASE}/Art/0_Previews`,
    totalCount: 35,
    imgExtension: '.jpg',
    categoryName: 'Art Deco',
    customStructure: true,
  },
  {
    name: 'Avatar_',
    alias: 'Avatar_',
    imgAlias: 'Avatar_',
    basePath: `${OBJECT_2025_BASE}/Avatar`,
    previewPath: `${OBJECT_2025_BASE}/Avatar/0_Previews`,
    totalCount: 8,
    imgExtension: '.jpg',
    categoryName: 'Avatar',
    customStructure: true,
  },
  {
    name: 'Avatar_',
    alias: 'Avatar_',
    imgAlias: 'Avatar_',
    basePath: `${OBJECT_2025_BASE}/Avatar`,
    previewPath: `${OBJECT_2025_BASE}/Avatar/0_Previews`,
    totalCount: 2,
    imgExtension: '.png',
    categoryName: 'Avatar',
    customStructure: true,
    startIndex: 9,
  },
  {
    name: 'Bridge_',
    alias: 'Bridge_',
    imgAlias: 'Bridge_',
    basePath: `${OBJECT_2025_BASE}/Bridges`,
    previewPath: `${OBJECT_2025_BASE}/Bridges/0_Previews`,
    totalCount: 13,
    imgExtension: '.jpg',
    categoryName: 'Bridges',
    customStructure: true,
  },
  {
    name: 'Building_',
    alias: 'Building_',
    imgAlias: 'Building_',
    basePath: `${OBJECT_2025_BASE}/Building`,
    previewPath: `${OBJECT_2025_BASE}/Building/0_Previews`,
    totalCount: 80,
    imgExtension: '.jpg',
    categoryName: 'Building',
    customStructure: true,
  },
  {
    name: 'Chair_',
    alias: 'Chair_',
    imgAlias: 'Chair_',
    basePath: `${OBJECT_2025_BASE}/Chairs`,
    previewPath: `${OBJECT_2025_BASE}/Chairs/0_Previews`,
    totalCount: 40,
    imgExtension: '.PNG',
    categoryName: 'Furniture',
    customStructure: true,
  },
  {
    name: 'Deco_',
    alias: 'Deco_',
    imgAlias: 'Deco_',
    basePath: `${OBJECT_2025_BASE}/Deco`,
    previewPath: `${OBJECT_2025_BASE}/Deco/0_Previews`,
    totalCount: 156,
    imgExtension: '.jpg',
    categoryName: 'Art Deco',
    customStructure: true,
  },
  {
    name: 'Furniture_',
    alias: 'Furniture_',
    imgAlias: 'Furniture_',
    basePath: `${OBJECT_2025_BASE}/Furniture`,
    previewPath: `${OBJECT_2025_BASE}/Furniture/0_Previews`,
    totalCount: 32,
    imgExtension: '.jpg',
    categoryName: 'Furniture',
    customStructure: true,
  },
  {
    name: 'Plants_',
    alias: 'Plants_',
    imgAlias: 'Plants_',
    basePath: `${OBJECT_2025_BASE}/Plants`,
    previewPath: `${OBJECT_2025_BASE}/Plants/0_Prviews`,
    totalCount: 17,
    imgExtension: '.jpg',
    categoryName: 'Plants',
    customStructure: true,
  },
  {
    name: 'Statues_',
    alias: 'Statues_',
    imgAlias: 'Statues_',
    basePath: `${OBJECT_2025_BASE}/Statues`,
    previewPath: `${OBJECT_2025_BASE}/Statues/0_previews`,
    totalCount: 10,
    imgExtension: '.jpg',
    categoryName: 'Artifacts',
    customStructure: true,
  },
  {
    name: 'Table_',
    alias: 'Table_',
    imgAlias: 'Table_',
    basePath: `${OBJECT_2025_BASE}/Tables`,
    previewPath: `${OBJECT_2025_BASE}/Tables/0_Previews`,
    totalCount: 39,
    imgExtension: '.jpg',
    categoryName: 'Furniture',
    customStructure: true,
  },
  {
    name: 'Vehicle_',
    alias: 'Vehicle_',
    imgAlias: 'Vehicle_',
    basePath: `${OBJECT_2025_BASE}/Vehicles`,
    previewPath: `${OBJECT_2025_BASE}/Vehicles/0_Previews`,
    totalCount: 81,
    imgExtension: '.jpg',
    categoryName: 'Vehicle',
    customStructure: true,
  },
  {
    name: 'Bridge_0',
    alias: 'Bridge_0',
    imgAlias: 'Bridge_0',
    basePath: `${ZEPETO_ASSETS_BASE}/ART_DECO`,
    totalCount: 10,
    imgExtension: '.jpg',
    categoryName: 'Art Deco',
  },
  {
    name: 'Deco_',
    alias: 'DECO_',
    imgAlias: 'Deco_',
    basePath: `${ZEPETO_ASSETS_BASE}/ART_DECO`,
    totalCount: 19,
    imgExtension: '.jpg',
    categoryName: 'Art Deco',
  },
  {
    name: 'Plant_',
    alias: 'PLANT_',
    imgAlias: 'Plant_',
    basePath: `${ZEPETO_ASSETS_BASE}/PLANTS`,
    totalCount: 10,
    imgExtension: '.jpg',
    categoryName: 'Plants',
  },
  {
    name: 'Vehicle_',
    alias: 'VEHICLE_',
    imgAlias: 'Vehicle_',
    basePath: `${ZEPETO_ASSETS_BASE}/VEHICLES`,
    totalCount: 10,
    imgExtension: '.jpg',
    categoryName: 'Vehicle',
  },
  {
    name: 'Prefab_',
    alias: 'PREFAB_',
    imgAlias: 'Prefab_',
    basePath: `${ZEPETO_ASSETS_BASE}/PREFABS_FREE`,
    totalCount: 7,
    imgExtension: '.jpg',
    type: 'prefab',
  },
  {
    name: 'Chair_',
    alias: 'CHAIR_',
    imgAlias: 'Chair_',
    imgExtension: '.jpg',
    basePath: `${ZEPETO_ASSETS_BASE}/FURNITURES`,
    totalCount: 9,
    categoryName: 'Furniture',
  },
  {
    name: 'Furniture_',
    alias: 'FURNITURE_',
    imgAlias: 'Furniture_',
    imgExtension: '.jpg',
    basePath: `${ZEPETO_ASSETS_BASE}/FURNITURES`,
    totalCount: 9,
    categoryName: 'Furniture',
  },
  {
    name: 'Table_',
    alias: 'TABLE_',
    imgAlias: 'Table_',
    basePath: `${ZEPETO_ASSETS_BASE}/FURNITURES`,
    totalCount: 20,
    imgExtension: '.jpg',
    categoryName: 'Furniture',
  },
];

const singleAssets = [] as any;
const prefabs = [] as any;

for (let i = 0; i < itemsTypes.length; i++) {
  const startIndex = itemsTypes[i].startIndex || 1;
  for (let j = startIndex; j < startIndex + itemsTypes[i].totalCount; j++) {
    let {
      alias,
      basePath,
      name,
      imgAlias,
      type,
      categoryName,
      imgExtension,
      previewPath,
      customStructure,
    } = itemsTypes[i];

    if (name.endsWith('0') && j >= 10) {
      name = name.slice(0, -1);
      imgAlias = imgAlias.slice(0, -1);
      alias = alias.slice(0, -1);
    }

    const previewImagePath = previewPath
      ? `${previewPath}/${imgAlias}${j}${imgExtension ?? '.png'}`
      : `${basePath}/${alias}${j}/${imgAlias}${j}${imgExtension ?? '.png'}`;

    if (type === 'prefab') {
      prefabs.push({
        assetURL: `${basePath}/${alias}${j}/${alias}${j}+GLTF/`,
        name: `${name}${j}`,
        fileType: 'MODEL',
        modelType: 'SCENE',
        previewImage: previewImagePath,
      });
    } else if (customStructure) {
      singleAssets.push({
        assetURL: `${basePath}/${alias}${j}/${name}${j}.gltf`,
        name: `${name}${j}`,
        categoryName,
        fileType: 'MODEL',
        modelType: 'MODEL',
        previewImage: previewImagePath,
      });
    } else {
      singleAssets.push({
        assetURL: `${basePath}/${alias}${j}/${alias}${j}+GLTF/${name}${j}.gltf`,
        name: `${name}${j}`,
        categoryName,
        fileType: 'MODEL',
        modelType: 'MODEL',
        previewImage: previewImagePath,
      });
    }
  }
}

const zepeto = Object.entries(zepetoItems)
  .reduce((prev, current) => {
    return prev.concat(current[1]);
  }, [] as any)
  .map((el) => {
    return {
      assetURL: el.url,
      name: el.name,
      previewImage: el.image,
      fileType: 'MODEL',
    };
  });

export const FREE_ASSETS = {
  all: prefabs
    .concat(singleAssets)
    .sort((a, b) =>
      a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })
    ),
  prefab: prefabs,
  single_asset: singleAssets,
  zepeto,
};
